/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs */



/**
* | output |
* | --- |
* | "Select All Events From Current" |
*
* @param {Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_select_all_events_from_current = /** @type {((inputs?: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner tous les evenements a partir de l'actuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Ereignisse aus der aktuellen Liste auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutti gli eventi da quelli correnti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрать все события из текущего списка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todos los eventos actuales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从当前事件中选择所有事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のすべてのイベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान में सभी इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione todos os eventos da lista atual.")
	return /** @type {LocalizedString} */ ("Select All Events From Current")
});